import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { CommonApiService } from 'src/app/services/common-api.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
// import { DecimalPipe } from '@angular/common';
import { CommaSeparatorPipe } from '../pipes/comma-separator.pipe';

@Component({
  selector: 'app-reports-page',
  templateUrl: './reports-page.component.html',
  styleUrls: ['./reports-page.component.css'],
  providers: [CommaSeparatorPipe],
})
export class ReportsPageComponent implements OnInit {
  enquiryForm!: FormGroup;
  moment: any = moment;
  searchItem = '';
  searchPO = '';
  tableHeight = '';
  tableWidth = '';
  body: any; // DATA FOR POST API
  DbAccess = '';
  userData: any = [];
  routeData: any;
  loadEnquiry = false;
  visible = false;
  deliveryOrderImage: any;
  invoiceImage: any;
  QCReportImage: any;
  grnData: any = [];
  invoiceNumber = '';
  remarks = '';
  // width = '1800px';

  // TABLE DATA
  orderColumn: any = [];
  reportList: any = [];

  downloadingPdf: any = false;

  invoiceData: any = {};

  addedFields: any = [];

  estimationHeadings: any = [
    {
      title: 'Part Code',
      width: '80px',
    },
    {
      title: 'Part Name',
      width: '120px',
    },
    {
      title: 'Qty',
      width: '50px',
    },
    {
      title: 'Unit Price',
      width: '100px',
    },
    {
      title: 'Total',
      width: '100px',
    },
  ];

  searchType: any = 'PONumber';

  taxTotal: number = 0;
  subTotal: number = 0;
  netTotal: any = 0;

  localSearch: any = '';

  invoiceUpdating: boolean = false;

  MTCType: string = '';
  invoiceType: string = '';
  QCReportType: string = '';

  docLink: string = '../../../assets/images/logo/doc_icon.png';

  docTypes = [
    // "text/plain",
    'application/pdf',
    'application/vnd.ms-powerpoint',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];

  errorIndex: number = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private apiService: CommonApiService,
    private spinner: NgxSpinnerService,
    public ete: ExportExcelService,
    private modal: NzModalService,
    private toastr: ToastrService // private decimalPipe: DecimalPipe
  ) {}

  ngOnInit(): void {
    // this.width = '1800px';
    if (window.innerWidth > 1300) {
      this.tableHeight = '60vh';
    } else {
      this.tableHeight = '50vh';
    }

    this.userData = JSON.parse(localStorage.getItem('qweuserdataqwe'));
    this.DbAccess =
      this.userData.dbAccess[0].dbDetails.dbCode +
      '~' +
      this.userData.dbAccess[0].companyDetails.bpCode;

    this.route.params.subscribe((params) => {
      this.invoiceData = {};
      this.reportList = [];
      // console.log(params);
      this.searchItem = '';
      this.searchPO = '';
      this.enquiryForm = this.fb.group({
        enquiryText: [null, [Validators.required]],
      });
      this.routeData = params;
      if (this.routeData.name == 'payments') {
        this.tableWidth = '800px';
        this.orderColumn = [
          {
            title: 'S.No',
            width: '40px',
          },
          {
            title: 'Doc Num',
            width: '60px',
          },
          {
            title: 'Doc Date',
            width: '100px',
          },
          {
            title: 'Card Code',
            width: '60px',
          },
          {
            title: 'Card Name',
            width: '100px',
          },
          {
            title: 'Cash Sum',
            width: '80px',
          },
        ];
      } else if (
        this.routeData.name != 'payments' &&
        this.routeData.name != 'shipment'
      ) {
        this.tableWidth = '1800px';
        this.orderColumn = [
          {
            title: 'S.No',
            width: '40px',
          },
          {
            title: 'Doc.Number',
            width: '120px',
          },
          {
            title: 'Doc.Status',
            width: '80px',
          },
          {
            title: 'Doc.Date',
            width: '80px',
          },
          {
            title: 'Doc.Due Date',
            width: '80px',
          },
          {
            title:
              JSON.parse(localStorage.getItem('qweuserdataqwe')).role ==
              'Supplier'
                ? 'Supplier Ref Number'
                : 'Customer Ref Number',
            width: '120px',
          },
          {
            title: 'Total',
            width: '80px',
          },
          {
            title: 'Tax Value',
            width: '80px',
          },
          {
            title: 'Document Total',
            width: '100px',
          },
          {
            title: 'Remarks',
            width: '350px',
          },
        ];
      } else if (this.routeData.name == 'shipment') {
        this.tableWidth = '2600px';
        this.orderColumn = [
          {
            title: 'S.No',
            width: '50px',
          },
          {
            title: 'PO Number',
            width: '80px',
          },
          {
            title: 'PODate',
            width: '80px',
          },
          {
            title: 'DueDate',
            width: '80px',
          },
          {
            title: 'Item No.',
            width: '130px',
          },
          {
            title: 'ItemName',
            width: '120px',
          },
          {
            title: 'Unit Price',
            width: '80px',
          },
          {
            title: 'POQty',
            width: '80px',
          },
          {
            title: 'Remaining Open Quantity',
            width: '180px',
          },
          {
            title: 'Delivery Qty',
            width: '160px',
          },
          {
            title: 'Balance Qty',
            width: '100px',
          },
          {
            title: 'FR Rej Qty',
            width: '140px',
          },
          {
            title: 'MR Rej Qty',
            width: '140px',
          },
          {
            title: 'StockInTransit',
            width: '120px',
          },
          {
            title: 'Remarks',
            width: '250px',
          },
        ];
      }
      if (this.routeData.name != 'info-enquiry') {
        this.fetchData(
          this.DbAccess.split('~')[1],
          this.DbAccess.split('~')[0]
        );
      }
    });

    // console.log(this.DbAccess);
  }

  fetchData(bpCode, dbCode) {
    this.spinner.show();
    this.reportList = [];
    // API BODY DATA
    this.body = {
      DBCode: dbCode,
      BPCode: bpCode,
      Index: 1,
      PONumber: this.searchPO ? this.searchPO : '',
      ItemCode: this.searchItem ? this.searchItem : '',
    };

    // API HEADER DATA
    let options = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + localStorage.getItem('lkjhgfdsa'))
        .set('Content-Type', 'application/json'),
    };

    // CALL METHOD FROM API SERVICE
    this.apiService
      .commonPostMethod(
        this.body,
        environment.newUrl + 'api/' + this.routeData.api,
        options
      )
      .subscribe(
        (response: any) => {
          this.reportList = response.responseData;
          console.log(response);
          if (this.grnData.length > 0) {
            for (let i = 0; i < this.grnData.length; i++) {
              const targetId = this.reportList.findIndex((e) => {
                return e.rowUniqueId == this.grnData[i].POrowUniqueId;
              });
              if (targetId > -1) {
                this.reportList[targetId].deliveryCount =
                  this.grnData[i].POQuantity;
              }
            }
          }
          // if(this.routeData.api == 'OpenPODetailedList'){
          //   for(var i = 0; i < this.reportList.length; i++){
          //     this.reportList[i].balanceQnty = 0;
          //   }
          // }
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          this.toastr.error(error.error.message, '', {
            timeOut: 2500,
          });
        }
      );
  }

  DbAccessChange() {
    // console.log(this.DbAccess);
    this.fetchData(this.DbAccess.split('~')[1], this.DbAccess.split('~')[0]);
  }

  // ENQUIRY SECTION STARTS

  sendEnquiry() {
    if (this.enquiryForm.valid) {
      this.loadEnquiry = true;
      let options = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      };
      let body = {
        CustomerCode: this.DbAccess.split('~')[1],
        LoginID: this.DbAccess.split('~')[0],
        Remarks: this.enquiryForm.value.enquiryText,
      };
      this.apiService
        .commonPostMethod(
          body,
          environment.newUrl + 'api/' + this.routeData.api,
          options
        )
        .subscribe(
          (response: any) => {
            if (response.statusMessage == 'Success') {
              this.loadEnquiry = false;
              this.toastr.success('Your Remarks Updated Successfully!', '', {
                timeOut: 2500,
              });
              this.enquiryForm.reset();
            } else if (response.statusMessage == 'Failed') {
              this.loadEnquiry = false;
              this.toastr.error(response.responseData.error, '', {
                timeOut: 2500,
              });
            }
            console.log(response);
          },
          (error) => {
            console.log(error);
            this.toastr.error(error.error.message, '', {
              timeOut: 2500,
            });
          }
        );
    } else {
      Object.values(this.enquiryForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  // ENQUIRY SECTION ENDS

  exportToExcel() {
    console.log(this.routeData);
    if (this.reportList.length == 0) {
      this.modal.error({
        nzTitle: 'Alert !',
        nzContent: 'No Data Found In Selected DB',
        nzOkText: 'Ok',
      });
    } else {
      console.log(this.reportList);
      var sales = [];
      for (let x = 0; x < this.reportList.length; x++) {
        if (
          this.routeData.name != 'payments' &&
          this.routeData.name != 'shipment'
        ) {
          var temp = [
            x + 1,
            parseFloat(this.reportList[x]?.docNum),
            this.reportList[x]?.docStatus,
            moment(this.reportList[x]?.docDate)?.format('DD-MM-YYYY  hh:mm a'),
            moment(this.reportList[x]?.docDueDate)?.format(
              'DD-MM-YYYY  hh:mm a'
            ),
            this.reportList[x].numAtCard,
            parseFloat(this.reportList[x]?.total?.toFixed(2)),
            parseFloat(this.reportList[x]?.vatSum?.toFixed(2)),
            parseFloat(this.reportList[x]?.docTotal?.toFixed(2)),
            this.reportList[x]?.comments,
          ];
          sales.push(temp);
        } else {
          var temp1 = [
            x + 1,
            parseFloat(this.reportList[x].poDocNum),
            moment(this.reportList[x].poDate).format('DD-MM-YYYY hh:mm a'),
            moment(this.reportList[x].dueDate).format('DD-MM-YYYY hh:mm a'),
            this.reportList[x].itemCode,
            this.reportList[x].itemName,
            parseFloat(this.reportList[x].price),
            parseFloat(this.reportList[x].poQty),
            parseFloat(this.reportList[x].openQty),
          ];
          sales.push(temp1);
        }

        temp = [];
        temp1 = [];
      }

      let reportData = {
        title: this.routeData.name.replaceAll('-', ' ').toUpperCase(),
        data: sales,
        headers: [],
      };

      if (
        this.routeData.name != 'payments' &&
        this.routeData.name != 'shipment'
      ) {
        reportData.headers = [
          'Sno',
          'Sales Order Number',
          'Doc.Status',
          'SO.Date',
          'Delivery Date',
          'Customer PO Number',
          'Total',
          'Tax Value',
          'Document Total',
          'Remarks',
        ];
      } else {
        reportData.headers = [
          'Sno',
          'Doc Num',
          'PO Date',
          'Due Date',
          'Item Code',
          'Item Name',
          'Unit Price',
          'PO Qty',
          'Remaining Open Quantity',
        ];
      }

      this.ete.exportExcel(
        reportData,
        this.routeData.name.replaceAll('-', ' ')
      );
    }
  }

  // TABLE PAGINATION

  onPageChange(event: any) {
    // console.log(event);
    if (document.getElementById('reportTable')) {
      document.getElementById('reportTable').scrollIntoView();
    }
  }

  enterValue(value: any, index: any) {
    this.errorIndex = null;
    for (let i = 0; i < this.reportList.length; i++) {
      if (this.reportList[i].itemCode == value.itemCode) {
        if (index <= i) {
          this.onEnter(value, index); // all commented lines in this function was for validate the same item id products was not empty
          break;
        } else {
          for (let j = 0; j < this.reportList.length; j++) {
            if (
              this.reportList[j].itemCode == value.itemCode &&
              (!this.reportList[j]?.deliveryCount ||
                this.reportList[j]?.deliveryCount <
                  this.reportList[j]?.openQty) &&
              j < index
            ) {
              this.reportList[index].deliveryCount = null;
              this.errorIndex = j;
              this.modal.error({
                nzTitle: 'Alert !',
                nzContent: 'Please Close the Previous Purchase Order',
                nzOkText: 'Ok',
              });
              break;
            } else if (
              this.reportList[j].itemCode == value.itemCode &&
              this.reportList[j]?.deliveryCount &&
              j < index
            ) {
              var targetIndex = this.grnData.findIndex((data) => {
                return data.POrowUniqueId == this.reportList[j].rowUniqueId;
              });

              if (targetIndex == -1) {
                this.errorIndex = j;
                this.modal.error({
                  nzTitle: 'Alert !',
                  nzContent: 'Please click add to Previous Purchase Order',
                  nzOkText: 'Ok',
                });
                break;
              }
            } else if (
              this.reportList[j].itemCode == value.itemCode &&
              this.reportList[j]?.deliveryCount &&
              j == index
            ) {
              this.onEnter(value, index);
              break;
            }
          }
          break;
        }
      }
    }
  }

  onEnter(count: any, index: any) {
    // console.log(count);
    let self = this;
    var reqValue;
    if ((count.openQty * 0.05).toString().split('.').length > 1) {
      reqValue = parseInt((count.openQty * 0.05).toString().split('.')[0]) + 1;
    } else {
      reqValue = parseInt(count.openQty) * 0.05;
      count.balanceQnty = count.deliveryCount - count.openQty;
    }
    var targetIndex = this.grnData.findIndex(
      (data) => data.POrowUniqueId == count.rowUniqueId
    );

    if (targetIndex > -1) {
      this.grnData[targetIndex].POQuantity = count.deliveryCount.toString();
    }

    // console.log(targetIndex);

    if (count.deliveryCount > reqValue + parseInt(count.openQty)) {
      var uniqueIndex = self.grnData.findIndex(
        (e) => e.POrowUniqueId === count.rowUniqueId
      );

      if (uniqueIndex != -1) {
        self.grnData.splice(uniqueIndex, 1);
      }
      self.toastr.error('wrong deliveryCount', '', { timeOut: 2500 });
    } else {
      var reqObj = {
        PODocEntry: count.docEntry,
        POLineNum: count.lineNum,
        POItemCode: count.itemCode,
        POQuantity: count.deliveryCount.toString(),
        // new values
        RteCrdNum: count?.rteCrdNum ? count.rteCrdNum : '',
        FGItemCodeLineNo: count?.fgItemCodeLineNo ? count.fgItemCodeLineNo : '',
        FGItemCode: count?.fgItemCode ? count.fgItemCode : '',
        FRRejQty: count?.FRRejQty ? count.FRRejQty : 0,
        MRRejQty: count?.MRRejQty ? count.MRRejQty : 0,
        WithUserRemarks: count?.remarks,
        // Not in postman request
        PORowNum: count.rowNum,
        POItemName: count.itemName,
        POUnitPrice: count.price,
        totalTax: count.totaTax,
        POrowUniqueId: count.rowUniqueId,
      };
      // console.log()
      if (self.addedFields.indexOf(count.rowUniqueId) == -1) {
        self.addedFields.push(count.rowUniqueId);
      }
      if (
        self.grnData.findIndex(
          (e) => e.POrowUniqueId === reqObj.POrowUniqueId
        ) == -1
      ) {
        self.grnData.push(reqObj);
      }
      self.invoiceData = count;
      // console.log(self.grnData);
    }
  }

  addRemark(value: any) {
    var targetIndex = this.grnData.findIndex((e) => {
      return e.POrowUniqueId == value.rowUniqueId;
    });

    if (targetIndex > -1) {
      this.grnData[targetIndex].WithUserRemarks = value.remarks;
    }
  }

  showDrawer() {
    // console.log(this.DbAccess);
    // this.formatAmount(987898765678);
    this.invoiceUpdating = false;
    this.errorIndex = null;
    var count = 0;
    let self = this;
    for (var i = 0; i < self.grnData.length; i++) {
      // console.log(self.grnData[i]);
      if (
        self.grnData[i].POQuantity != undefined &&
        self.grnData[i].POQuantity != '' &&
        self.grnData[i].POQuantity != '0'
      ) {
        // alert(self.reportList[i].deliveryCount + " "+ typeof self.reportList[i].deliveryCount);
        count++;
      }
    }
    if (self.grnData.length > 0 && count == self.grnData.length) {
      this.reset();
      this.getTotal();
      self.visible = true;
    } else {
      //alert('Enter Delivery Count');
      self.toastr.error(
        'Enter Delivery Count or hit the Enter Button after entering the Delivery Count ',
        '',
        { timeOut: 2500 }
      );
    }

    console.log(self.grnData);
  }

  close() {
    this.visible = false;
  }

  getDelOrdImageFile(event: any) {
    let self = this;
    self.MTCType = event.target.files[0].type;
    let file = event.target.files[0];
    const fileSizeMB: any = (file.size / 1000000).toFixed(2); // convert bytes to MB
    // console.log(fileSizeMB);
    if (fileSizeMB <= 5) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        //me.modelvalue = reader.result;
        //console.log(reader.result);
        self.deliveryOrderImage = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    } else {
      this.toastr.error('File size must be less than 5MB', '', {
        timeOut: 3500,
      });
    }
  }

  getQCReportImage(event: any) {
    let self = this;
    self.QCReportType = event.target.files[0].type;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      self.QCReportImage = reader.result;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  reset() {
    let self = this;
    self.invoiceImage = '';
    self.QCReportImage = '';
    self.deliveryOrderImage = '';
    self.invoiceNumber = '';
    self.remarks = '';
    self.close();
  }

  pdfData: any;
  qrData: any;

  addGRPO() {
    this.pdfData = '';
    this.qrData = '';
    let self = this;
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    if (self.invoiceNumber == '') {
      self.toastr.error('Enter Invoice Number', '', { timeOut: 2500 });
    }
    // else if(self.remarks == ''){
    //   self.toastr.error('Enter Remarks', '', { timeOut: 2500 });
    // }
    else if (!self.deliveryOrderImage) {
      self.toastr.error('Select MTC Attachment', '', { timeOut: 2500 });
    } else if (!self.invoiceImage) {
      self.toastr.error('Select Invoice Attachment', '', { timeOut: 2500 });
    }
    // else if (!self.QCReportImage) {
    //   self.toastr.error('Select QC Report Attachment', '', { timeOut: 2500 });
    // }
    else {
      this.invoiceUpdating = true;
      var reqData = {
        DBCode: self.DbAccess.split('~')[0],
        cardcode: self.DbAccess.split('~')[1],
        // DBCode: self.userData.dbAccess[0].dbDetails.dbCode,
        // cardcode: self.userData.dbAccess[0].companyDetails.bpCode,
        DOBase64Str: self.deliveryOrderImage.split(',')[1],
        InvoiceBase64Str: self.invoiceImage.split(',')[1],
        QCReportBase64Str: !self.QCReportImage
          ? ''
          : self.QCReportImage.split(',')[1],
        DOFileType: 'jpg',
        invoiceNumber: self.invoiceNumber,
        InvoiceFileType: 'jpg',
        Remarks: self.remarks,
        DraftGRPOPostingDetails: self.grnData,
      };

      console.log(reqData);

      self.apiService
        .commonPostMethod(
          reqData,
          environment.newUrl + 'api/DraftGRPOPosting',
          options
        )
        .subscribe(
          (response: any) => {
            console.log(response);

            if (response.statusMessage == 'Success') {
              self.pdfData = response.responseData.split(',');
              self.qrData = self.pdfData[0].split(':');
              self.addedFields = [];
              self.toastr.success('Uploaded Successfully', '', {
                timeOut: 2500,
              });
              self.visible = false;
              self.localSearch = '';
              self.grnData = [];
              self.fetchData(
                self.DbAccess.split('~')[1],
                self.DbAccess.split('~')[0]
              );
              // const doc = new jsPDF({
              //   orientation: 'landscape',
              // });

              // doc.text(response.responseData.split(',')[0], 120, 80);
              // doc.text(response.responseData.split(',')[1], 119, 90);

              // doc.save('grpo.pdf');
              self.downloadingPdf = true;
              setTimeout(() => {
                this.saveAsPdf();
              }, 200);

              self.close();
            } else {
              self.invoiceUpdating = false;
              self.toastr.error(response.responseData, '', {
                timeOut: 10000,
              });
            }
          },
          (error) => {
            console.log(error);
            self.invoiceUpdating = false;
            self.toastr.error(error.error.message, '', {
              timeOut: 10000,
            });
          }
        );
    }
  }

  getInvoiceImageFile(event: any) {
    let self = this;
    self.invoiceType = event.target.files[0].type;
    let file = event.target.files[0];
    const fileSizeMB: any = (file.size / 1000000).toFixed(2); // convert bytes to MB
    // console.log(fileSizeMB);
    if (fileSizeMB <= 5) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        //me.modelvalue = reader.result;
        //console.log(reader.result);
        self.invoiceImage = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    } else {
      this.toastr.error('File size must be less than 5MB', '', {
        timeOut: 3500,
      });
    }
  }

  saveAsPdf() {
    html2canvas(document.querySelector('#download_pdf')).then((canvas) => {
      var doc = new jsPDF('p', 'mm');
      var imgData = canvas.toDataURL('image/png');
      // doc.addPage();
      doc.addImage(imgData, 'PNG', 0, 0, 210, 297);
      doc.save('grpo.pdf');
      this.downloadingPdf = false;
    });
  }

  countChange(index: number, value: any) {
    this.errorIndex = null;
    for (let i = 0; i < this.reportList.length; i++) {
      if (this.reportList[i].itemCode == value.itemCode) {
        if (index <= i) {
          // console.log('first report');
          this.count(index, value); // all commented lines in this function was for validate the same item id products was not empty
          break;
        } else {
          for (let j = 0; j < this.reportList.length; j++) {
            if (
              this.reportList[j].itemCode == value.itemCode &&
              (!this.reportList[j]?.deliveryCount ||
                this.reportList[j]?.deliveryCount <
                  this.reportList[j]?.openQty) &&
              j < index
            ) {
              this.reportList[index].deliveryCount = null;
              this.errorIndex = j;
              // alert('please fill previous field with this PO Number');
              this.modal.error({
                nzTitle: 'Alert !',
                nzContent: 'Please Close the Previous Purchase Order',
                nzOkText: 'Ok',
              });
              break;
            } else if (
              this.reportList[j].itemCode == value.itemCode &&
              this.reportList[j]?.deliveryCount &&
              j < index
            ) {
              var targetIndex = this.grnData.findIndex((data) => {
                return data.POrowUniqueId == this.reportList[j].rowUniqueId;
              });

              if (targetIndex == -1) {
                this.errorIndex = j;
                this.modal.error({
                  nzTitle: 'Alert !',
                  nzContent: 'Please click add to Previous Purchase Order',
                  nzOkText: 'Ok',
                });
                break;
              }
            } else if (
              this.reportList[j].itemCode == value.itemCode &&
              this.reportList[j]?.deliveryCount &&
              j == index
            ) {
              this.count(index, value);
              break;
            }
          }
          break;
        }
      }
    }
  }

  count(index: number, value: any) {
    // console.log(this.grnData);
    if (this.addedFields.indexOf(value.rowUniqueId) > -1) {
      this.addedFields.splice(this.addedFields.indexOf(value.rowUniqueId), 1);
    }

    var targetIndex = this.grnData.findIndex((data: any) => {
      return data.POrowUniqueId === value.rowUniqueId;
    });

    if (targetIndex > -1 && !value.deliveryCount) {
      this.grnData.splice(targetIndex, 1);
    }
  }

  rejQTYchange(value: any, type: string, index: number) {
    // console.log(value);
    // console.log(
    //   (value.FRRejQty ? value.FRRejQty : 0) +
    //     (value.MRRejQty ? value.MRRejQty : 0)
    // );
    if (!value.deliveryCount) {
      this.toastr.error('Please add delivery quantity first', '', {
        timeOut: 2500,
      });
      value.FRRejQty = null;
      value.MRRejQty = null;
    } else if (
      (value.FRRejQty ? value.FRRejQty : 0) +
        (value.MRRejQty ? value.MRRejQty : 0) >
      value.deliveryCount
    ) {
      if (type == 'MR') {
        value.MRRejQty = null;
      } else {
        value.FRRejQty = null;
      }
      this.toastr.error(
        'Sum of FR Rej Qty and FR Rej Qty have to less than Delivery Quantity',
        '',
        {
          timeOut: 2500,
        }
      );
    } else {
      // console.log(this.grnData);
      // console.log(value);
      var targetIndex = this.grnData.findIndex((e) => {
        return e.POrowUniqueId == value.rowUniqueId;
      });

      if (targetIndex > -1) {
        this.grnData[targetIndex].FRRejQty = value.FRRejQty;
        this.grnData[targetIndex].MRRejQty = value.MRRejQty;
      }
    }
  }

  getTotal() {
    this.subTotal = this.grnData
      .reduce(
        (total, obj) =>
          total +
          parseFloat(obj['POUnitPrice']) * parseFloat(obj['POQuantity']),
        0
      )
      .toFixed(2);

    this.taxTotal = this.grnData
      .reduce(
        (total, obj) =>
          total + parseFloat(obj['totalTax']) * parseFloat(obj['POQuantity']),
        0
      )
      .toFixed(2);

    this.netTotal = (
      parseFloat(this.subTotal.toString()) +
      parseFloat(this.taxTotal.toString())
    ).toFixed(2);
  }

  searchRecords() {
    // alert(this.searchType);
    this.localSearch = '';
    this.fetchData(this.DbAccess.split('~')[1], this.DbAccess.split('~')[0]);
  }

  formatAmount(value: number) {
    console.log(value);
    // const result = this.decimalPipe.transform(value, '1.0-0');
    // console.log(result);
  }

  inputKeyUp(type: string) {
    if (type == 'po' && !this.searchPO) {
      this.searchRecords();
    } else if (type == 'items' && !this.searchItem) {
      this.searchRecords();
    }
  }
}
